import { render } from "./OverviewTable.vue?vue&type=template&id=e13b5b4a"
import script from "./OverviewTable.vue?vue&type=script&lang=js"
export * from "./OverviewTable.vue?vue&type=script&lang=js"

import "./OverviewTable.vue?vue&type=style&index=0&id=e13b5b4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__